import * as base64url from '../runtime/base64url.js';
export const encode = base64url.encode;
export const decode = base64url.decode;



// WEBPACK FOOTER //
// ./~/jose/dist/browser/util/base64url.js